module.exports = __webpack_public_path__ + "img/Group12465@2x.e35c14ee.png";